(function() {
  var style = document.createElement('style');
  style.textContent = '@keyframes rotator{0%{transform:rotate(0deg)}100%{transform:rotate(270deg)}}@keyframes dash{0%{stroke-dashoffset:187}50%{stroke-dashoffset:46;transform:rotate(135deg)}100%{stroke-dashoffset:187;transform:rotate(450deg)}}'
    + '#rv-quick-modal .radio__fieldset{display:flex!important; justify-content: flex-start;}'
    + 'body:not(.template-cart) span.radio__legend__label {align-items: baseline !important; flex-direction: column !important;}'
  document.head.appendChild(style);
})();

var RV_CART_SVG = [
  '<svg xmlns="http://www.w3.org/2000/svg"',
  ' width="18" height="18" viewBox="0 0 24 24"',
  ' fill="none" stroke="currentColor"',
  ' stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',
  '<circle cx="9" cy="21" r="1"></circle>',
  '<circle cx="20" cy="21" r="1"></circle>',
  '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>',
  '</svg>'
].join('');

window.rvCloseModal = function() {
  var drawer = document.getElementById('rv-quick-drawer');
  var modal = document.getElementById('rv-quick-modal');
  drawer.style.transform = 'translateY(100%)';
  setTimeout(function() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }, 300);
};

window.rvOpenQuickAdd = function(handle) {
  var modal = document.getElementById('rv-quick-modal');
  var content = document.getElementById('rv-quick-modal-content');
  content.innerHTML = '<p>Loading...</p>';
  modal.style.display = 'block';
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(function() {
    document.getElementById('rv-quick-drawer').style.transform = 'translateY(0)';
  });

  Promise.all([
    fetch('/products/' + handle + '.js').then(function(r) { return r.json(); }),
    fetch('/products/' + handle + '?sections=rv-product-meta').then(function(r) { return r.json(); })
  ]).then(function(results) {
    var product = results[0];
    var meta = results[1];
    (function(product, meta) {
      var variant = product.variants[0];
      var html = '<div style="display:flex;gap:1rem;margin-bottom:1rem;align-items:center;">'
        + '<img src="' + product.featured_image + '" width="80" height="80"'
        + ' style="width:80px;height:80px;object-fit:cover;border-radius:4px;">'
        + '<div>'
        + '<p style="margin:0;font-weight:bold;">' + product.title + '</p>'
        + '<p style="margin:0;" id="rv-modal-price">$' + (variant.price / 100).toFixed(2) + '</p>'
        + '</div></div>';

      var optNames = product.options.map(function(o) { return typeof o === 'object' ? o.name : o; });
      if (optNames[0] !== 'Title') {
        optNames.forEach(function(opt, oi) {
          var values = product.variants
            .map(function(v) { return v.options[oi]; })
            .filter(function(v, i, a) { return a.indexOf(v) === i; });

          html += '<fieldset class="js product-form__input radio__fieldset">'
            + '<legend class="radio__legend">'
            + '<span class="radio__legend__label">'
            + '<span class="radio__legend__option-name">' + opt + '</span>'
            + '<small class="radio__legend__value" id="rv-legend-' + oi + '">' + values[0] + '</small>'
            + '</span></legend>'
            + '<div class="radio__buttons">';

          values.forEach(function(val, vi) {
            var inputId = 'rv-input-' + oi + '-' + vi;
            html += '<span class="radio__button">'
              + '<input type="radio" id="' + inputId + '"'
              + ' name="rv-option-' + oi + '"'
              + ' value="' + val + '"'
              + ' data-rv-opt="' + oi + '"'
              + (vi === 0 ? ' checked' : '') + '>'
              + '<label for="' + inputId + '">'
              + '<span class="option-title">' + val + '</span>'
              + '</label></span>';
          });

          html += '</div></fieldset>';
        });
      }

      var desc = meta['rv-product-meta'] ? meta['rv-product-meta'].trim() : '';
      if (desc) {
        html += '<div class="rte" style="font-size:0.85em;margin-top:1rem;padding-top:1rem;border-top:1px solid rgba(0,0,0,0.1);max-height:120px;overflow-y:auto;">'
          + desc
          + '</div>';
      }

      html += '<input type="hidden" id="rv-variant-id" value="' + variant.id + '">'
        + '<button onclick="rvAddToCart()" class="button button--primary"'
        + ' style="width:100%;margin-top:1rem;">Add to Bag</button>';

      content.innerHTML = html;

      var allVariants = product.variants;
      content.querySelectorAll('[data-rv-opt]').forEach(function(input) {
        input.addEventListener('change', function() {
          var legendVal = document.getElementById('rv-legend-' + this.dataset.rvOpt);
          if (legendVal) legendVal.textContent = this.value;

          var selected = [];
          product.options.forEach(function(_, i) {
            var c = content.querySelector('[name="rv-option-' + i + '"]:checked');
            if (c) selected[i] = c.value;
          });
          var matched = allVariants.find(function(v) {
            return v.options.every(function(o, i) { return o === selected[i]; });
          });
          if (matched) {
            document.getElementById('rv-variant-id').value = matched.id;
            document.getElementById('rv-modal-price').textContent = '$' + (matched.price / 100).toFixed(2);
          }
        });
      });
    })(product, meta);
  });
};

window.rvAddToCart = function() {
  var id = document.getElementById('rv-variant-id').value;
  var btn = document.querySelector('#rv-quick-modal-content .button--primary');
  var originalHTML = btn.innerHTML;
  btn.disabled = true;
  btn.innerHTML = '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width:1.5em;height:1.5em;animation:rotator 1.4s linear infinite;vertical-align:middle;"><circle class="path" fill="none" stroke="white" stroke-width="6" cx="33" cy="33" r="30" style="stroke-dasharray:187;stroke-dashoffset:187;transform-origin:center;animation:dash 1.4s ease-in-out infinite;"></circle></svg>';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(id), quantity: 1 })
  }).then(function() {
    btn.innerHTML = '✓';
    setTimeout(function() { window.location.href = '/cart'; }, 800);
  }).catch(function() {
    btn.innerHTML = originalHTML;
    btn.disabled = false;
  });
};

setTimeout(function() {
  var viewed = JSON.parse(localStorage.getItem('rec_recently_viewed') || '[]');
  if (!viewed.length) return;
  var container = document.getElementById('recently-viewed-products');
  if (!container) return;

  var promises = viewed.slice(0, 3).map(function(p) {
    return fetch('/products/' + p.handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        var variant = product.variants[0];
        var price = '$' + (p.price / 100).toFixed(2);
        var cp = (p.comparePrice && p.comparePrice > p.price)
          ? '<s style="opacity:0.5;margin-left:4px;">$' + (p.comparePrice / 100).toFixed(2) + '</s>'
          : '';
        var btn = '<button type="button"'
          + ' onclick="rvOpenQuickAdd(\'' + p.handle + '\')"'
          + ' style="padding:8px;background:none;border:1px solid;border-radius:4px;cursor:pointer;margin-top:4px;">'
          + RV_CART_SVG
          + '</button>';
        return '<li>'
          + '<a href="/products/' + p.handle + '">'
          + '<img src="' + p.image + '" loading="lazy"></a>'
          + '<div>'
          + '<a href="/products/' + p.handle + '" style="text-decoration:none;color:inherit;font-size:0.85em;">' + p.title + '</a>'
          + '<span style="font-weight:bold;font-size:0.85em;">' + price + cp + '</span>'
          + btn
          + '</div></li>';
      });
  });

  Promise.all(promises).then(function(items) {
    container.innerHTML = '<ul style="list-style:none;padding:0;margin:0;display:flex;flex-direction:column;gap:12px;">'
      + items.join('')
      + '</ul>';
  });

  var modal = document.getElementById('rv-quick-modal');
  if (modal) {
    modal.addEventListener('click', function(e) {
      if (e.target === modal) rvCloseModal();
    });
  }
}, 800);
